import { Components, Theme } from '@mui/material';

import { formControlStyles } from './MuiFormControl';

export const MuiTextField: Components<Theme>['MuiTextField'] = {
  styleOverrides: {
    root: {
      ...formControlStyles,

      '& input:-webkit-autofill': {
        WebkitBoxShadow: '0 0 0 100px transparent inset',
        WebkitTextFillColor: '#FFFFFF',
        transition: 'background-color 5000s ease-in-out 0s',
      },
      '& input:-webkit-autofill:focus': {
        WebkitBoxShadow: '0 0 0 100px transparent inset',
        WebkitTextFillColor: '#FFFFFF',
        transition: 'background-color 5000s ease-in-out 0s',
      },

      '& input': {
        fontSize: '16px !important',
      },
    },
  },
};
